module.exports = __webpack_public_path__ + "img/laurel-gitlen-3.b2690443.png";